import React from "react";
import { Phone, ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EmergencyRapidResponse() {
  return <section data-section-id="7245" id="emergency-support" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-500 to-blue-800 z-0">
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-transparent pointer-events-none" />
      </div>

      {}
      <div className="relative z-10 max-w-7xl mx-auto px-4 flex flex-col items-center text-center">
        
        {}
        <div className="mb-8 inline-flex items-center gap-3 bg-white/10 backdrop-blur-md px-5 py-2.5 rounded-full border border-white/20 shadow-xl animate-in fade-in slide-in-from-bottom-4 duration-700">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-300"></span>
          </span>
          <span className="text-white font-bold text-sm tracking-widest uppercase drop-shadow-sm">
            Active: Central Coast Rapid Response
          </span>
        </div>

        {}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 tracking-tighter drop-shadow-2xl animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100">
          Emergency? <span className="text-blue-200 inline-block">We're on our way.</span>
        </h2>

        {}
        <p className="text-lg md:text-2xl text-white/90 max-w-3xl mb-12 leading-relaxed font-medium drop-shadow-md animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200">
          From burst pipes to blocked drains, our licensed Narara team is ready to restore your home 24/7. Don't wait for the damage to spread.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-6 w-full sm:w-auto animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
          {}
          <Button asChild size="lg" className="bg-white text-blue-900 hover:bg-white/90 border-none shadow-[0_20px_40px_rgba(0,0,0,0.3)] hover:shadow-[0_25px_50px_rgba(0,0,0,0.4)] hover:-translate-y-1 transition-all duration-300 text-xl h-16 px-12 rounded-full font-black">
            <Link to="tel:0417818188">
              <Phone className="mr-2 h-7 w-7" />
              Call 0417 818 188
            </Link>
          </Button>

          {}
          <Button asChild size="lg" className="bg-white/10 backdrop-blur-lg text-white hover:bg-white/20 border border-white/30 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-lg h-16 px-10 rounded-full font-bold">
            <Link to="/ContactPage">
              Request Urgent Repair
              <ArrowRight className="ml-2 h-6 w-6" />
            </Link>
          </Button>
        </div>

        {}
        
      </div>
    </section>;
}